import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import CreateSchemaWizard from '../../components/schema/generate-schema/CreateSchemaWizard';
import ContentBlocker from "../../components/context/ContentBlocker";

class GenerateSchemaPage extends React.Component {

  render() {
    return (
      <Row className="GenerateSchemaPage py-3">
        <Col>
          <h1>Create Schema from Ontologies</h1>
          <ContentBlocker checkCreatePermission={true}>
            <CreateSchemaWizard/>
          </ContentBlocker>
        </Col>
      </Row>
    );
  }
}

export default GenerateSchemaPage;
